import template from './uc-config-page.html.twig';
import './uc-config-page.scss';

const { Mixin } = Shopware;

Shopware.Component.register('uc-config-page', {
    template,

    inject: ['systemConfigApiService'],

    mixins: [
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            salesChannelId: null,
            currentTheme: 'classic',
            elementOrder: '["trust-bar","timer","progress-bar","gift-offers","line-items","cross-sell","usp-grid","discount","order-summary","custom-html","custom-html-2","custom-html-3"]',
            disabledElements: '[]',
            isSaving: false,
        };
    },

    created() {
        this.loadCustomConfig();
    },

    methods: {
        async loadCustomConfig() {
            try {
                const values = await this.systemConfigApiService.getValues(
                    'SellopsUltimateCart.config',
                    this.salesChannelId
                );
                this.currentTheme = values['SellopsUltimateCart.config.theme'] ?? 'classic';
                this.elementOrder = values['SellopsUltimateCart.config.elementOrder']
                    ?? '["trust-bar","timer","progress-bar","gift-offers","line-items","cross-sell","usp-grid","discount","order-summary","custom-html","custom-html-2","custom-html-3"]';
                this.disabledElements = values['SellopsUltimateCart.config.disabledElements'] ?? '[]';
            } catch {
                // Defaults already set in data()
            }
        },

        // Single Save button — saves all sw-system-config fields FIRST, then
        // our custom-tracked fields (theme + elementOrder) LAST so they always win.
        // theme/elementOrder are NOT in config.xml, so sw-system-config never
        // touches them — but saving our values last is an extra safety net.
        async onSave() {
            this.isSaving = true;
            let hasError = false;

            // 1. Save sw-system-config fields first
            if (this.$refs.systemConfig) {
                try {
                    if (typeof this.$refs.systemConfig.save === 'function') {
                        await this.$refs.systemConfig.save();
                    } else if (typeof this.$refs.systemConfig.saveAll === 'function') {
                        await this.$refs.systemConfig.saveAll();
                    }
                } catch (e) {
                    console.error('[UltimateCart] Failed to save system config fields:', e);
                    hasError = true;
                }
            }

            // 2. Save custom-tracked fields (theme + elementOrder) last — always wins
            try {
                await this.systemConfigApiService.saveValues({
                    'SellopsUltimateCart.config.theme':            this.currentTheme,
                    'SellopsUltimateCart.config.elementOrder':     this.elementOrder,
                    'SellopsUltimateCart.config.disabledElements': this.disabledElements,
                }, this.salesChannelId);
            } catch (e) {
                console.error('[UltimateCart] Failed to save custom config:', e);
                hasError = true;
            }

            this.isSaving = false;

            if (hasError) {
                this.createNotificationError({
                    message: this.$tc('sellops-ultimate-cart.config.saveError'),
                });
            } else {
                this.createNotificationSuccess({
                    message: this.$tc('sellops-ultimate-cart.config.saveSuccess'),
                });
            }
        },

        onThemeChange(value) {
            this.currentTheme = value;
        },

        onElementOrderChange(value) {
            this.elementOrder = value;
        },

        onDisabledElementsChange(value) {
            this.disabledElements = value;
        },

        onSystemConfigChanged() {
            // sw-system-config tracks its own field state internally
        },

        // Keep salesChannelId in sync so the milestone manager re-filters on switch
        onSalesChannelChanged(salesChannelId) {
            this.salesChannelId = salesChannelId ?? null;
            this.loadCustomConfig();
        },

        goToMilestones() {
            this.$router.push({ name: 'sellops.ultimate.cart.milestones' });
        },

        goToFreeProducts() {
            this.$router.push({ name: 'sellops.ultimate.cart.freeproducts' });
        },

        goToCrossSellRules() {
            this.$router.push({ name: 'sellops.ultimate.cart.crosssellrules' });
        },
    },
});
